module.exports = __webpack_public_path__ + "img/SC9-Occupation_Rating.fa6a5b70.png";